document.addEventListener("DOMContentLoaded", function () {
 
  const headerContainers = document.querySelectorAll(".header-nav-blocks");
  const crossIcons = document.querySelectorAll(".menu-close-icon");
  const mainMenus = document.querySelectorAll(".custom-details-disclosure");
  const bodyClass = document.querySelector(".btn-hover-effect-default");


  crossIcons.forEach((icon) => {
    icon.addEventListener("click", (e) => {
      const button_test = e.target.closest(".menu-close-icon");
      if (!button_test) return;
      headerContainers.forEach((container) => {
        container.classList.remove("megamenu-block");
      });

      mainMenus.forEach((menu) => {
        menu.classList.remove("open");
        menu.removeAttribute("open");
      });

      if (bodyClass) {
        bodyClass.classList.remove("megamenu-open");
      }
    });
  });


  document.addEventListener("click", function (e) {
    const showMoreButton = e.target.closest(".show-more-li");

    if (showMoreButton) {
      const showmorebutton_svgs = showMoreButton.querySelector(".chev-icons");

      const showMoreItems = document.querySelector(".show-more-li-items");
      const isHidden = showMoreItems.classList.contains("hidden");

      showMoreButton.innerHTML = "";

      if (isHidden) {
        showMoreItems.classList.remove("hidden");
        showMoreButton.innerHTML = `
      Show Less
       <span class='chev-icons'>
        <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-up"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6 15l6 -6l6 6" /></svg>
        </span>
      `;
      } else {
        showMoreItems.classList.add("hidden");
        showMoreButton.innerHTML = `
      Show More
       <span class='chev-icons'>
        <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6 9l6 6l6 -6" /></svg>
        </span>
      `;
      }
    }
  });



document.querySelectorAll(".quantity-of-product").forEach(input => {
    input.addEventListener("input", () => {
      const wrapper = input.closest(".product-quantity-with-buy");
      if (!wrapper) return;
      const hiddenInput = wrapper.querySelector(".hidden-quantity-input");
      let val = parseInt(input.value);
      if (isNaN(val) || val < 1) val = 1;
      input.value = val;
      if (hiddenInput) hiddenInput.value = val;
    });
  });

  document.querySelectorAll(".product-form").forEach(form => {
    form.addEventListener("submit", (event) => {
      const wrapper = form.closest(".product-quantity-with-buy");
      if (!wrapper) return;
      const visibleInput = wrapper.querySelector(".quantity-of-product");
      const hiddenInput = wrapper.querySelector(".hidden-quantity-input");
      if (visibleInput && hiddenInput) {
        hiddenInput.value = visibleInput.value;
      }
    });
  });
 
 document.querySelectorAll('[data-quantity-input]').forEach((input) => {
  const max = parseInt(input.dataset.available);
  const min = parseInt(input.getAttribute('min')) || 1;

  const wrapper = input.closest('.product-quantity-with-buy');
  const decrementBtn = wrapper ? wrapper.querySelector('[data-quantity-decrement]') : null;

  input.addEventListener('input', () => {
    let value = parseInt(input.value);

    if (isNaN(value) || value < min) {
      input.value = min;
    } else if (value > max) {
      input.value = max;
    }

    if (max > 1 && decrementBtn) {
      decrementBtn.classList.remove('disabled-minus');
      decrementBtn.removeAttribute('tabindex');
      decrementBtn.removeAttribute('aria-disabled');
    }
  });

  input.addEventListener('keydown', (e) => {
    if (['e', 'E', '+', '-'].includes(e.key)) {
      e.preventDefault();
    }
  });

  if (max > 1 && decrementBtn) {
    decrementBtn.classList.remove('disabled-minus');
    decrementBtn.removeAttribute('tabindex');
    decrementBtn.removeAttribute('aria-disabled');
  }
});



const multiplediscountoption = document.querySelectorAll('.multiple-discount-quantity');
if(multiplediscountoption)
{ 
  multiplediscountoption.forEach(element => {
    element.addEventListener('click',function(){ 

      const dataquantity = element.querySelector('.multiple-discount-quantity-value').getAttribute('data-quantity-value');
      const mainprdquanityinput = document.querySelector('.product-main-quantity');
      
      mainprdquanityinput.value = dataquantity

      const mainquantitywrapper= mainprdquanityinput.closest('.pdp-main-product-qty');
      
      mainquantitywrapper.classList.add("quantity-added-grid");

    })
  });
}

  
});


async function fetchProductJson(handle) {
  try {
    const [product, metafieldsData] = await Promise.all([
      fetch(`/products/${handle}.js`).then(r => r.ok ? r.json() : null),
      fetch(`/products/${handle}?view=metafields`)
        .then(r => r.ok ? r.json() : {})
        .catch(() => ({}))
    ]);

    if (!product) return null;

    product.metafields = metafieldsData?.metafields || {};
    product.url = `/products/${handle}`;

    return product;

  } catch (error) {
    console.error('Failed to fetch product JSON for', handle, error);
    return null;
  }
}


function createProductHtml(product, showdiscountOff = false, cartQty = 0, preorder = false) {
  const currentVariant = product.variants ? product.variants[0] : null;
  const isTaxable = currentVariant?.taxable ?? false;
  const reviewAverageRating = product.metafields?.['app--2519111--reviews']?.review_average_rating;
  const reviewWrapperClass = reviewAverageRating ? 'has-review' : 'no-review';
  const brandLogo = product?.metafields?.custom?.brand_logo;

  const brandSection = brandLogo
    ? `<img src="${brandLogo}" alt="${product.vendor || ''}" height="" width="">`
    : product.vendor
      ? `<p class="product-detail-item vendor">${product.vendor}</p>`
      : '';

  return `
  <div class="trending-content product-card">
  <div class="card-drawer-product-card">
  <div class="cart-drawer-card-top">
    <a class="trending-product-img" href="${product.url}">
      <div class="cart-image-wrapper" style="--imageRatio: ${product.featured_media?.preview_image?.aspect_ratio ? (1 / product.featured_media.preview_image.aspect_ratio * 100) + '%' : '100%'};">
        <img src="${product.featured_image || (product.images && product.images.length ? product.images[0] : '')}" alt="${product.title}" loading="lazy" />
      </div>
    </a>
    <div class="trending-product-detail">
      ${brandSection}
      <a href="${product.url}" class="product-title">${product.title}</a>
    </div>
  </div>

  <div class="cart-drawer-card-bottom">
    <div class="price">
      
      ${isTaxable
        ? `
        <span class="cart-drawer-price price-inc-vat">£${(product.price / 100).toFixed(2)} <span class="inc-vat-label vat-label">Inc VAT</span></span>
        <span class="cart-drawer-price price-ex-vat">£${(product.price / 100 / 1.2).toFixed(2)} <span class="ex-vat-label vat-label"> Ex VAT </span></span>`
        : `<span class="cart-drawer-price">£${(product.price / 100).toFixed(2)} </span>`}
    </div>
    <form method="post" action="/cart/add" class="add-to-cart-form ajax-add-to-cart">
      <input type="hidden" name="id" value="${currentVariant ? currentVariant.id : ''}">
      <button type="submit" class="btn button add-to-cart-button"
        ${(!product.available || product.inventory_quantity <= cartQty) ? 'disabled aria-disabled="true"' : ''}
      >
        ${!product.available ? 'Out of Stock' : preorder ? 'Preorder' : 'Add to basket'}
      </button>
    </form>
  </div>
  </div>
  </div>
  `;
}

async function renderRecommendedForLastViewedProduct() {
  const container = document.querySelector('.recommended-products');
  if (!container) return;

  container.innerHTML = '<div class="products-loading-spinner"><span></span></div>';

  try {
    const cart = await fetch('/cart.js').then(r => r.ok ? r.json() : null);
    const latestItem = cart?.items?.[0];
    if (!latestItem?.product_id) {
      container.innerHTML = '<p>No recent cart item.</p>';
      return;
    }

    const rec = await fetch(`/recommendations/products.json?product_id=${latestItem.product_id}&limit=3`)
      .then(r => r.ok ? r.json() : { products: [] });
    const recs = Array.isArray(rec.products) ? rec.products.slice(0, 3) : [];

    if (!recs.length) {
      container.innerHTML = '<p>No recommendations available.</p>';
      return;
    }

    const products = await Promise.all(recs.map(p => fetchProductJson(p.handle)));
    const validProducts = products.filter(p => p !== null).slice(0, 3);

    container.innerHTML = validProducts.map(p => createProductHtml(p)).join('');

  } catch (e) {
    console.error('renderRecommendedForLastViewedProduct error', e);
    container.innerHTML = '<p>Failed to load recommendations.</p>';
  }
}

async function renderRecentlyViewedProducts() {
  const container = document.querySelector('.recently-viewed-products');
  if (!container) return;

  const handles = JSON.parse(localStorage.getItem('recently-viewed-products') || '[]').slice(0, 3);
  if (handles.length === 0) {
    container.innerHTML = '<p>No recently viewed products.</p>';
    return;
  }

  container.innerHTML = '<div class="products-loading-spinner"><span></span></div>';

  const products = await Promise.all(handles.map(handle => fetchProductJson(handle)));
  const validProducts = products.filter(p => p !== null);

  if (validProducts.length === 0) {
    container.innerHTML = '<p>No recently viewed products available.</p>';
    return;
  }

  container.innerHTML = validProducts.map(createProductHtml).join('');
}

document.addEventListener('DOMContentLoaded', () => {
  renderRecommendedForLastViewedProduct();
  renderRecentlyViewedProducts();
  
  
});

function equalizeHeights(containerSelector) {
  const cards = document.querySelectorAll(
    containerSelector + ' .product-grid-box'
  );
  if (!cards.length) return;

  cards.forEach(el => (el.style.height = 'auto'));

  let maxH = 0;
  cards.forEach(el => {
    if (el.offsetHeight > maxH) maxH = el.offsetHeight;
  });

  cards.forEach(el => (el.style.height = maxH + 'px'));
}

function equalizeAllSliders() {
  equalizeHeights('.related-products-section');
  equalizeHeights('.recently-viewed-products-section');
}

[
  '.related-products-section',
  '.recently-viewed-products-section',
  '.best_seller',
  '.summer-slider-bg'
].forEach(containerSelector => {
  const sliderEl = document.querySelector(
    containerSelector + ' [data-slideshow]'
  );
  if (!sliderEl) return;

  const flkty = Flickity.data(sliderEl);
  if (!flkty) return;

  flkty.on('ready',        equalizeAllSliders);
  flkty.on('imagesLoaded', equalizeAllSliders);
  flkty.on('cellSelect',   equalizeAllSliders);
});

window.addEventListener('load',   equalizeAllSliders);
window.addEventListener('resize', debounce(equalizeAllSliders, 300));

if (window.location.pathname === '/cart') {
  const scrollPos = sessionStorage.getItem('cartScrollPos');
  if (scrollPos) {
    window.scrollTo({ top: parseInt(scrollPos), behavior: 'instant' });
    sessionStorage.removeItem('cartScrollPos');
  }
}